export default "__VITE_ASSET__Ck9klupd__"